import React from 'react';

import { Modal as AntdModal } from 'antd';
import moment from 'moment';

import { RpsiFluxDto } from 'lib_api/lib/api/gen';

import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { DATE_FORMAT } from 'utils/formats';

interface ModalDetailsProps {
  flux: RpsiFluxDto;
  visible: boolean;
  close: () => void;
}

function ModalErrors({
  flux,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <AntdModal
      visible={visible}
      onCancel={close}
      footer={null}
      destroyOnClose={true}
      width={BaseModalWidthUtils.largeWidth}
      maskClosable={true}
      className="modalError"
    >
      <h3>
        {`Messages d’erreur sur l’import du ${moment(flux.dateAppel).format(
          DATE_FORMAT,
        )}`}
      </h3>
      <ul>
        {flux.errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    </AntdModal>
  );
}

export default ModalErrors;
